// extracted by mini-css-extract-plugin
module.exports = {"img":"FeatureCard_img__uEuHR","title":"FeatureCard_title__zWtdu","card":"FeatureCard_card__nRhu4"};